import React, { useEffect, useMemo, useState } from 'react';
import { IGridConfig } from '../../../types/grid';
import Grid from '../../common/grid/Grid';
import { MarsApiService as api } from '../../../api/mars-api-service';
import { MarsApiConfig as apiConfig } from '../../../api/mars-api-config';
import { useLoaderContext } from '../../../contexts/LoaderContext';
import { useTranslation } from 'react-i18next';
import jsPDF from 'jspdf';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import 'jspdf-autotable';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';
import Button from 'devextreme-react/button';
import icons from '../../common/icons/icons';
import Popover from 'devextreme-react/popover';
import { useResize } from '../../../hooks/useResize';

export default React.memo(function VetTurnAroundTimeTrendGadget() {
  const { setIsLoading } = useLoaderContext();
  const [vetTurnAroundTimeTrendGadget, setVetTurnAroundTimeTrendGadget] =
    useState<any>();
  const { t } = useTranslation();
  const [gridInstance, setGridInstance] = useState<any>();
  const [showExportPopover, setShowExportPopover] = useState(false);
  const exportPopupAttributes = useMemo(() => {
    return {
      id: 'elementId',
      class: 'm-l-dashboard__chart-export',
      'data-testid': 'rolePopover',
    };
  }, []);

  const onRowClick = (e: any) => {
    e.preventDefault();
    return false;
  };

  useEffect(() => {
    getVetTurnAroundTimeTrendGadget();
  }, []);

  const getVetTurnAroundTimeTrendGadget = async () => {
    await api
      .get(
        {
          url: apiConfig.vetTurnAroundTimeTrend,
        },
        setIsLoading
      )
      .then((data: any) => {
        setVetTurnAroundTimeTrendGadget(data.turnaroundTimeTrendList);
      });
  };

  const onGridInitialized = (e: any) => {
    setGridInstance(e.component);
  };

  const cellPrepared = (e: any) => {
    if (e.column.dataField === 'change' && e.data?.change.charAt(0) === '-') {
      e.cellElement.className = 'status-active';
    } else if (
      e.column.dataField === 'change' &&
      e.data?.change.charAt(0) === '+'
    ) {
      e.cellElement.className = 'status-inactive';
    }
  };

  const gridConfig: IGridConfig = {
    dataSource: vetTurnAroundTimeTrendGadget,
    cellPrepared: cellPrepared,
    defaultColumns: [
      {
        name: 'timePeriod',
        dataField: 'timePeriod',
        dataType: 'string',
        minWidth: 50,
        caption: ' ',
      },
      {
        name: 'Hrs',
        dataField: 'hours',
        dataType: 'string',
        minWidth: 50,
        caption: t('labels.Hrs'),
      },
      {
        name: 'Change',
        dataField: 'change',
        dataType: 'string',
        minWidth: 50,
        caption: t('labels.change'),
      },
    ],
    rowClick: onRowClick,
    hideFilterRow: true,
    hidePagination: true,
    initialized: onGridInitialized,
  };

  const fileFormats = [
    {
      id: 1,
      name: 'Excel File',
      value: 'xlsx',
    },
    {
      id: 2,
      name: 'PDF File',
      value: 'pdf',
    },
  ];

  const exportRolesGrid = (format: any) => {
    if (format === 'xlsx') {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Main sheet');

      exportDataGrid({
        component: gridInstance,
        worksheet: worksheet,
      }).then(function () {
        workbook.xlsx.writeBuffer().then(function (buffer) {
          saveAs(
            new Blob([buffer], { type: 'application/octet-stream' }),
            `VetTurnaroundTimeTrend.${format}`
          );
        });
      });
    } else if (format === 'pdf') {
      const doc = new jsPDF();
      exportDataGridToPdf({
        jsPDFDocument: doc,
        component: gridInstance,
      }).then(() => {
        doc.save('VetTurnarountTimeTrend.pdf');
      });
    }
  };

  const { isMobileResolution } = useResize();
  const [position, setPosition] = useState<any>('bottom');
  useEffect(() => {
    if (isMobileResolution) {
      setPosition('left');
    } else {
      setPosition('bottom');
    }
  }, [isMobileResolution]);

  return (
    <div className="m-c-grid m-c-block-grid-list">
      <div className="m-c-form-group u-mb0">
        <div className="row">
          <div className="col-16 d-flex ps-4 pe-4">
            <div className="ml-dashboard-export">
              <Button
                id="TurnAroundTimeTrend"
                className="app-c-btn app-c-btn--secondary m-c-icon-inside-secondary-button"
                aria-label="Export-btn"
                onClick={() => setShowExportPopover(true)}
              >
                <div className="m-c-icon-inside-btn" data-testid="export-all">
                  <icons.download />
                </div>
              </Button>
              <Popover
                target="#TurnAroundTimeTrend"
                position={position}
                width={132}
                visible={showExportPopover}
                wrapperAttr={exportPopupAttributes}
                closeOnOutsideClick={true}
                onHiding={() => setShowExportPopover(false)}
              >
                <ul className="ml-expport-list">
                  {/* <li>Print</li> */}
                  {fileFormats.map((role: any, index: any) => {
                    return (
                      <li
                        key={index}
                        onClick={() => exportRolesGrid(role.value)}
                      >
                        {role.name}
                      </li>
                    );
                  })}
                </ul>
              </Popover>
            </div>
          </div>
        </div>
      </div>
      <Grid gridConfig={gridConfig} statusTemplate={cellRender} />
    </div>
  );
});

function cellRender(data: any) {
  return <div>{data.value}</div>;
}
